import { render, staticRenderFns } from "./inputMaker.vue?vue&type=template&id=6a8163f3"
import script from "./inputMaker.vue?vue&type=script&lang=js"
export * from "./inputMaker.vue?vue&type=script&lang=js"
import style0 from "./inputMaker.vue?vue&type=style&index=0&id=6a8163f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports